// extracted by mini-css-extract-plugin
export default {"cls1":"SearchBar-cls1__e743063083f9fd41ee1d","cls2":"SearchBar-cls2___3d9c16c971c37a9fc89 SearchBar-cls1__e743063083f9fd41ee1d"};